import { render, staticRenderFns } from "./DsdcLevelSelector.vue?vue&type=template&id=45e7355b"
import script from "./DsdcLevelSelector.vue?vue&type=script&lang=js"
export * from "./DsdcLevelSelector.vue?vue&type=script&lang=js"
import style0 from "./DsdcLevelSelector.vue?vue&type=style&index=0&id=45e7355b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports